import React from 'react';
import { Particles } from './animations/Particles';
import { Beams } from './animations/Beams';
import { Squares } from './animations/Squares';
import { Threads } from './animations/Threads';
import { OrbitField } from './animations/OrbitField';
import { Lightning } from './animations/Lightning';
import { Waves } from './animations/Waves';
import { Aurora } from './animations/Aurora';
import { Hyperspeed } from './animations/Hyperspeed';
import { MatrixRain } from './animations/MatrixRain';
import { RippleGrid } from './animations/RippleGrid';
import { GlowOrbs } from './animations/GlowOrbs';
import { Spotlight } from './animations/Spotlight';
import { Constellation } from './animations/Constellation';
import { CircuitGrid } from './animations/CircuitGrid';
export type FxVariant =
// primitives
'particles' | 'beams' | 'squares' | 'threads' | 'orbit' | 'orbit-left' | 'orbit-right' | 'lightning' | 'waves' | 'aurora'
// dramatic ReactBits-style
| 'hyperspeed' | 'matrix' | 'ripple' | 'glow-orbs' | 'spotlight' | 'constellation' | 'circuit'
// composed
| 'aurora-particles' | 'beams-squares' | 'matrix-aurora' | 'orbs-spotlight' | 'hyperspeed-aurora' | 'none';
interface SectionFxProps {
  variant: FxVariant;
  className?: string;
}
export function SectionFx({
  variant,
  className = ''
}: SectionFxProps) {
  return <div className={`absolute inset-0 pointer-events-none ${className}`} data-id="element-807">
      {/* === Primitives === */}
      {variant === 'particles' && <Particles count={70} data-id="element-808" />}
      {variant === 'beams' && <Beams count={6} data-id="element-809" />}
      {variant === 'squares' && <Squares lit={14} data-id="element-810" />}
      {variant === 'threads' && <Threads count={7} data-id="element-811" />}
      {variant === 'orbit' && <OrbitField center={{
      x: 50,
      y: 50
    }} size={500} data-id="element-812" />}
      {variant === 'orbit-left' && <OrbitField center={{
      x: 15,
      y: 50
    }} size={420} count={3} data-id="element-813" />}
      {variant === 'orbit-right' && <OrbitField center={{
      x: 85,
      y: 50
    }} size={420} count={3} data-id="element-814" />}
      {variant === 'lightning' && <Lightning interval={3} data-id="element-815" />}
      {variant === 'waves' && <Waves count={4} data-id="element-816" />}
      {variant === 'aurora' && <Aurora intensity={0.25} data-id="element-817" />}

      {/* === Dramatic === */}
      {variant === 'hyperspeed' && <>
          <Aurora intensity={0.18} data-id="element-818" />
          <Hyperspeed count={180} data-id="element-819" />
        </>}
      {variant === 'matrix' && <>
          <Aurora intensity={0.18} data-id="element-820" />
          <MatrixRain density={0.7} data-id="element-821" />
        </>}
      {variant === 'ripple' && <>
          <Aurora intensity={0.18} data-id="element-822" />
          <RippleGrid rows={9} cols={16} data-id="element-823" />
        </>}
      {variant === 'glow-orbs' && <GlowOrbs count={6} data-id="element-824" />}
      {variant === 'spotlight' && <>
          <Aurora intensity={0.18} data-id="element-825" />
          <Spotlight data-id="element-826" />
        </>}
      {variant === 'constellation' && <>
          <Aurora intensity={0.15} data-id="element-827" />
          <Constellation nodes={55} linkDistance={0.18} data-id="element-828" />
        </>}
      {variant === 'circuit' && <>
          <Aurora intensity={0.15} data-id="element-829" />
          <CircuitGrid rows={5} cols={9} data-id="element-830" />
        </>}

      {/* === Composed === */}
      {variant === 'aurora-particles' && <>
          <Aurora intensity={0.2} data-id="element-831" />
          <Particles count={50} data-id="element-832" />
        </>}
      {variant === 'beams-squares' && <>
          <Squares lit={10} data-id="element-833" />
          <Beams count={4} data-id="element-834" />
        </>}
      {variant === 'matrix-aurora' && <>
          <Aurora intensity={0.3} data-id="element-835" />
          <MatrixRain density={0.5} data-id="element-836" />
        </>}
      {variant === 'orbs-spotlight' && <>
          <GlowOrbs count={4} data-id="element-837" />
          <Spotlight size={600} data-id="element-838" />
        </>}
      {variant === 'hyperspeed-aurora' && <>
          <Aurora intensity={0.25} data-id="element-839" />
          <Hyperspeed count={140} speed={0.7} data-id="element-840" />
        </>}

      {/* Vignette to keep content readable */}
      <div className="absolute inset-0" style={{
      background: 'radial-gradient(ellipse at center, transparent 30%, rgba(5,6,8,0.55) 90%)'
    }} data-id="element-841" />
    </div>;
}